var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasConnection)?_c('q-banner',{staticClass:"text-white bg-negative network-connectivity"},[_c('span',{staticClass:"text-bold"},[_vm._v("You have lost your network connection. This app is offline.")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }